import * as React from 'react';

import { UitkCardPlaceholder } from 'uitk-react-cards';

import { Lazy, LazyProps } from './lazy';

interface SimpleLazyLoadWrapperProps extends LazyProps {
  placeholder?: any;
  children: any;
}

/**
 * This component simplified lazy loading - @jullberg
 */
export const SimpleLazyLoadWrapper: React.FunctionComponent<SimpleLazyLoadWrapperProps> = ({
  children,
  placeholder = <UitkCardPlaceholder />,
  ...props
}) => (
  <Lazy {...props}>
    <Lazy.Placeholder>{placeholder}</Lazy.Placeholder>
    <Lazy.Loaded>{children}</Lazy.Loaded>
  </Lazy>
);
